// Define event types that is returned from feed, and whether
// the user should receive notifications for them
export var EVENTS = [{
  type: 'created',
  notify: false
}, {
  type: 'sending_queued',
  notify: false
}, {
  type: 'sending_error',
  notify: true
}, {
  type: 'sent',
  notify: true
}, {
  type: 'deleted',
  notify: false
}, {
  type: 'email_read',
  notify: false
}, {
  type: 'link_clicked',
  notify: false
}, {
  type: 'document_read',
  notify: false
}, {
  type: 'partially_signed',
  notify: true
}, {
  type: 'signed',
  notify: true
}, {
  type: 'packaged',
  notify: false
}, {
  type: 'extended_deadline',
  notify: false
}];